import { render, staticRenderFns } from "./TooltipHelpText.vue?vue&type=template&id=1fc1ad26"
import script from "./TooltipHelpText.vue?vue&type=script&lang=js"
export * from "./TooltipHelpText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports